import Emitter from "./Emitter";

export default class ExitFullScreen extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        const doc = window.document;
        const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

        if(doc.fullscreenElement && doc.mozFullScreenElement && doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            const userAgent = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : null;

            if (userAgent.indexOf("android") > -1) {
                cancelFullScreen.call(doc);
            }
        }
    }
}
